import "../../common/styles/insight-popup.scss"

import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideClimateInformationPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"

// Components
import Popup, { PopupContent } from "@modules/popup/Popup"
import { ClimateInformation } from "@ng-mw/shared-react-components/insight-lazy"
import LazyRender from "@ng-mw/reol/components/LazyRender"

const ClimateInformationPopup = () => {
    const dispatch = useDispatch<any>()
    const isOpen = useSelector((state: RootState) => state.app.climateInformationPopup.visible)

    return (
        <Popup
            onClose={() => dispatch(hideClimateInformationPopup())}
            isOpen={isOpen}
            className="insight-popup"
        >
            <PopupContent>
                <LazyRender
                    isVisible={isOpen}
                    hiddenClassName=""
                >
                    <ClimateInformation />
                </LazyRender>
            </PopupContent>
        </Popup>
    )
}

export default ClimateInformationPopup
